export default __webpack_public_path__ + "static/media/app-visual-3.da221023.png";